export default "__VITE_ASSET__54721615__"